(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('AppointmentTypeService', ['$http', 'SharedAgendaService', AppointmentTypeServiceFn]);

    /* service for requesting appointment types */
    function AppointmentTypeServiceFn($http, SharedAgendaService) {
        var baseUrl = '/api/appointmenttypes/';

        var service = {
            query: query,
            queryByUserId: queryByUserId,
            deactivate: deactivate,
            update: update,
            save: save,
            list: list,
            get: get
        };

        return service;

        /* get appointmenttypes of agenda */
        function query(agendaId, all) {
            return $http.get(baseUrl + 'agendas/' + agendaId + '/' + (all ? all : false)).then(function (response) {
                return response.data;
            });
        }

        /* get appointmenttypes of userId */
        function queryByUserId(userId, all) {
            return $http.get(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id + '/users/' + userId + '/' + (all ? all : false)).then(function (response) {
                return response.data;
            });
        }

        /* get appointment type */
        function get(id) {
            return $http.get(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }

        /* deactivate appointment type */
        function deactivate(appointmenttypeId) {
            return $http.delete(baseUrl + appointmenttypeId + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }

        /* update appointment type */
        function update(appointmenttypeId, item) {
            return $http.put(baseUrl + appointmenttypeId + '/agendas/' + SharedAgendaService.data.currentAgenda.id, item).then(function (response) {
                return response.data;
            });
        }

        /* save appointment type */
        function save(item) {
            return $http.post(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id, item).then(function (response) {
                return response.data;
            });
        }

        /* list of appointment-types grouped by agenda-label */
        function list(agendaId) {
            return $http.get(baseUrl + 'agendas/' + agendaId + '/grouped').then(function (response) {
                return response.data;
            });
        }
    }
})();